export default "__VITE_ASSET__B83K4o0P__"